import classNames from 'classnames';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlFormTextBlockProps } from './form.props';
import { getGlobalStyleSheets } from '../../global-styles';
import { Sizes, enumAttributeConverter, SizesValuesMap } from '../enum-types';

import * as TagNames from './form.tagnames';

@customElement(TagNames.FormTextBlock)
export class AtlFormTextBlock
   extends LitElement
   implements AtlFormTextBlockProps
{
   declare inputId: string;
   declare inputClassName?: string;
   declare size?: Sizes;

   static properties = {
      inputId: { type: String },
      inputClassName: { type: String },
      size: {
         type: String,
         convertor: enumAttributeConverter(Sizes, Sizes.Medium),
      },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      return html`
         <div
            id=${this.inputId}
            class=${classNames(
               'input-group',
               this.inputClassName,
               SizesValuesMap[this.size ?? Sizes.Medium]
            )}
            title=${this.title}
         >
            <slot></slot>
         </div>
      `;
   }
}
